import script from "./CardResultados.vue?vue&type=script&setup=true&lang=js"
export * from "./CardResultados.vue?vue&type=script&setup=true&lang=js"

import "./CardResultados.vue?vue&type=style&index=0&id=fdf6a3dc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdf6a3dc"]])

export default __exports__